/**
 * Duplicated services/koda/api/src/Enum/ArrestTarget.php
 * Must be kept in sync
 */
export const ArrestTarget = {
  EARREST: 'earrest',
  EPIS: 'epis',
};
